<!-- ===== HERO ===== -->
<section class="hero" id="hero">
  <div class="hero-inner container">
    <div class="hero-copy">
      <div class="hero-boot" aria-hidden="true">
        <span class="boot-line">&gt; PC-01 BOOT_SEQUENCE</span>
        <span class="boot-ok">[ OK ]</span>
      </div>

      <div class="hero-location">
        <span class="dot-sol"></span>
        <span>{{ t.hero_location }}</span>
        <span class="hero-coords" aria-hidden="true">32.95°S · 60.65°O</span>
      </div>

      <h1 class="hero-title">
        <span class="glitch ht-l1" [attr.data-text]="t.hero_line1">{{ t.hero_line1 }}</span><br>
        <em class="glitch ht-l2" [attr.data-text]="t.hero_line2">{{ t.hero_line2 }}</em>
      </h1>

      <div class="hero-panel">
        <span class="hp-c tl"></span><span class="hp-c tr"></span><span class="hp-c bl"></span><span class="hp-c br"></span>
        <p class="hero-desc" [innerHTML]="t.hero_desc"></p>
      </div>

      <div class="hero-tele" aria-hidden="true">
        <div class="tele">
          <span class="tele-k">{{ t.tele_projects }}</span>
          <span class="tele-v">25+</span>
          <span class="tele-bar"><i style="--w: 82%"></i></span>
        </div>
        <div class="tele">
          <span class="tele-k">{{ t.tele_years }}</span>
          <span class="tele-v">08</span>
          <span class="tele-bar"><i style="--w: 64%"></i></span>
        </div>
        <div class="tele">
          <span class="tele-k">{{ t.tele_mode }}</span>
          <span class="tele-v tele-rojo">{{ t.tele_mode_val }}</span>
          <span class="tele-bar"><i style="--w: 100%"></i></span>
        </div>
      </div>

      <div class="hero-cta">
        <a class="btn btn-primary" (click)="scrollTo('servicios')"><span class="btn-pre" aria-hidden="true">&gt;_</span>{{ t.cta_services }}</a>
        <a class="btn btn-secondary" (click)="scrollTo('trabajos')">{{ t.cta_works }}<span class="btn-post" aria-hidden="true">→</span></a>
      </div>
    </div>

    <!-- Robot: armadura roja de perfil, con HUD de escaneo -->
    <div class="robot" aria-hidden="true">
      <div class="robot-glow"></div>

      <svg class="robot-hud" viewBox="0 0 600 600">
        <circle class="hud-ring hud-ring-1" cx="300" cy="300" r="290" />
        <circle class="hud-ticks" cx="300" cy="300" r="270" />
        <circle class="hud-ring hud-ring-2" cx="300" cy="300" r="250" />
        <circle class="hud-ring hud-ring-3" cx="300" cy="300" r="214" />
      </svg>

      <span class="hud-corner tl"></span>
      <span class="hud-corner tr"></span>
      <span class="hud-corner bl"></span>
      <span class="hud-corner br"></span>

      <span class="smoke s1"></span>
      <span class="smoke s2"></span>
      <span class="smoke s3"></span>

      <svg class="robot-svg" viewBox="0 0 260 262">
        <defs>
          <linearGradient id="pc-rojo" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#FF6A5C"/><stop offset=".22" stop-color="#E32A2A"/><stop offset=".5" stop-color="#B80D17"/>
            <stop offset=".78" stop-color="#7E0008"/><stop offset="1" stop-color="#3E0004"/>
          </linearGradient>
          <linearGradient id="pc-sombra" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#000" stop-opacity="0"/><stop offset=".6" stop-color="#000" stop-opacity=".15"/><stop offset="1" stop-color="#000" stop-opacity=".6"/>
          </linearGradient>
          <linearGradient id="pc-cable" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stop-color="#1A1E24"/><stop offset=".45" stop-color="#5A6372"/><stop offset=".6" stop-color="#2A3038"/><stop offset="1" stop-color="#090A0D"/>
          </linearGradient>
          <linearGradient id="pc-visor" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#6C7686"/><stop offset=".25" stop-color="#1A1F27"/><stop offset=".7" stop-color="#050608"/><stop offset="1" stop-color="#22262E"/>
          </linearGradient>
          <radialGradient id="pc-metal" cx=".35" cy=".3" r=".75">
            <stop offset="0" stop-color="#8E98A8"/><stop offset=".4" stop-color="#2E343D"/><stop offset="1" stop-color="#07080A"/>
          </radialGradient>
          <radialGradient id="pc-luz" cx=".5" cy=".5" r=".6">
            <stop offset="0" stop-color="#FFF4F4"/><stop offset=".4" stop-color="#FF4D4D"/><stop offset="1" stop-color="#990000"/>
          </radialGradient>
          <radialGradient id="pc-oscuro" cx=".5" cy=".4" r=".7">
            <stop offset="0" stop-color="#20242B"/><stop offset="1" stop-color="#050608"/>
          </radialGradient>
          <filter id="pc-blur" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="3"/></filter>
          <filter id="pc-blur-s" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="1"/></filter>
          <filter id="pc-ao" x="-60%" y="-300%" width="220%" height="700%"><feGaussianBlur stdDeviation="5"/></filter>
          <filter id="pc-brillo" x="-120%" y="-120%" width="340%" height="340%">
            <feGaussianBlur stdDeviation="2.4" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <!-- Pintura con laca: relieve y brillo especular desde arriba a la izquierda -->
          <filter id="pc-pintura" x="-6%" y="-6%" width="112%" height="112%" color-interpolation-filters="sRGB">
            <feGaussianBlur in="SourceAlpha" stdDeviation="2.4" result="b"/>
            <feSpecularLighting in="b" surfaceScale="4" specularConstant="1.1" specularExponent="32" lighting-color="#FFF1EC" result="s">
              <fePointLight x="30" y="-40" z="170"/>
            </feSpecularLighting>
            <feComposite in="s" in2="SourceAlpha" operator="in" result="si"/>
            <feGaussianBlur in="SourceAlpha" stdDeviation="1.2" result="borde"/>
            <feComposite in="SourceAlpha" in2="borde" operator="out" result="contorno"/>
            <feFlood flood-color="#1A0002" flood-opacity="0.7"/>
            <feComposite in2="contorno" operator="in" result="oscuro"/>
            <feComposite in="SourceGraphic" in2="si" operator="arithmetic" k2="1" k3="0.6" result="lacado"/>
            <feMerge><feMergeNode in="lacado"/><feMergeNode in="oscuro"/></feMerge>
          </filter>
          <!-- Acero: textura cepillada + relieve -->
          <filter id="pc-acero" x="-10%" y="-10%" width="120%" height="120%" color-interpolation-filters="sRGB">
            <feGaussianBlur in="SourceAlpha" stdDeviation="1.6" result="b"/>
            <feSpecularLighting in="b" surfaceScale="3" specularConstant="0.9" specularExponent="22" lighting-color="#E1EAF2" result="s">
              <fePointLight x="30" y="-40" z="170"/>
            </feSpecularLighting>
            <feComposite in="s" in2="SourceAlpha" operator="in" result="si"/>
            <feTurbulence type="fractalNoise" baseFrequency="0.05 1.2" numOctaves="2" seed="4" result="n"/>
            <feColorMatrix in="n" type="saturate" values="0" result="g"/>
            <feComponentTransfer in="g" result="grano">
              <feFuncR type="linear" slope="0.35" intercept="0.72"/>
              <feFuncG type="linear" slope="0.35" intercept="0.72"/>
              <feFuncB type="linear" slope="0.35" intercept="0.72"/>
              <feFuncA type="linear" slope="0" intercept="1"/>
            </feComponentTransfer>
            <feComposite in="grano" in2="SourceAlpha" operator="in" result="granoIn"/>
            <feBlend in="SourceGraphic" in2="granoIn" mode="multiply" result="tex"/>
            <feComposite in="si" in2="tex" operator="arithmetic" k2="0.7" k3="1"/>
          </filter>
          <radialGradient id="pc-reflejo">
            <stop offset="0" stop-color="#FF3020" stop-opacity="0.55"/>
            <stop offset="1" stop-color="#FF3020" stop-opacity="0"/>
          </radialGradient>
          <filter id="pc-tinta" x="-10%" y="-10%" width="120%" height="120%">
            <feTurbulence type="fractalNoise" baseFrequency="1.4" numOctaves="1" seed="9" result="r"/>
            <feDisplacementMap in="SourceGraphic" in2="r" scale="0.6" result="d"/>
            <feGaussianBlur in="d" stdDeviation="0.18"/>
          </filter>
        </defs>

        <g>
          <defs>
            <linearGradient id="pc-cromo" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stop-color="#5A6372"/><stop offset=".45" stop-color="#E8EDF3"/><stop offset="1" stop-color="#3A404A"/>
            </linearGradient>
          </defs>

          <!-- estructura interna oscura (se ve entre placas) -->
          <path d="M84 148 L152 136 L182 150 L214 150 L246 176 L254 262 L44 262 L48 214 C50 186 64 162 84 148 Z" [attr.fill]="u('pc-oscuro')"/>
          <path d="M150 206 L176 202 M150 216 L178 212 M150 226 L178 222 M150 236 L176 232 M150 246 L174 242" stroke="#2E343D" stroke-width="3" stroke-linecap="round"/>
          <path d="M150 206 L176 202 M150 216 L178 212 M150 226 L178 222 M150 236 L176 232 M150 246 L174 242" stroke="#6B7584" stroke-width=".7" stroke-linecap="round" opacity=".6" transform="translate(0 -1)"/>
          <g class="rb-cables">
            <path d="M156 112 C186 126 214 150 228 186" fill="none" stroke="#0B0D11" stroke-width="7.5" stroke-linecap="round"/>
            <path d="M156 112 C186 126 214 150 228 186" fill="none" [attr.stroke]="u('pc-cable')" stroke-width="6" stroke-linecap="round"/>
            <path d="M156 112 C186 126 214 150 228 186" fill="none" stroke="#000" stroke-width="6" stroke-dasharray="1 2.6" opacity=".55"/>
            <path d="M156 112 C186 126 214 150 228 186" fill="none" stroke="#9AA4B3" stroke-width="1.2" stroke-linecap="round" opacity=".5" transform="translate(-1.5 0)"/>
            <path d="M150 120 C176 140 196 166 206 204" fill="none" stroke="#0B0D11" stroke-width="6.5" stroke-linecap="round"/>
            <path d="M150 120 C176 140 196 166 206 204" fill="none" [attr.stroke]="u('pc-cable')" stroke-width="5" stroke-linecap="round"/>
            <path d="M150 120 C176 140 196 166 206 204" fill="none" stroke="#000" stroke-width="5" stroke-dasharray="1 2.6" opacity=".55"/>
            <path d="M150 120 C176 140 196 166 206 204" fill="none" stroke="#9AA4B3" stroke-width="1" stroke-linecap="round" opacity=".5" transform="translate(-1.2 0)"/>
            <path d="M162 104 C196 112 226 134 244 170" fill="none" stroke="#0B0D11" stroke-width="6" stroke-linecap="round"/>
            <path d="M162 104 C196 112 226 134 244 170" fill="none" [attr.stroke]="u('pc-cable')" stroke-width="4.5" stroke-linecap="round"/>
            <path d="M162 104 C196 112 226 134 244 170" fill="none" stroke="#000" stroke-width="4.5" stroke-dasharray="1 2.6" opacity=".55"/>
            <path d="M162 104 C196 112 226 134 244 170" fill="none" stroke="#9AA4B3" stroke-width="0.9" stroke-linecap="round" opacity=".5" transform="translate(-1.1 0)"/>
          </g>

          <!-- brazo superior -->
          <path d="M182 194 L234 194 L246 262 H188 Z" fill="#0B0D10"/>
          <path d="M196 204 L204 262" stroke="#050608" stroke-width="5" stroke-linecap="round"/><path d="M196 204 L204 262" [attr.stroke]="u('pc-cromo')" stroke-width="3" stroke-linecap="round"/>
          <path d="M208 202 L218 262" stroke="#050608" stroke-width="5" stroke-linecap="round"/><path d="M208 202 L218 262" [attr.stroke]="u('pc-cromo')" stroke-width="3" stroke-linecap="round"/>
          <path d="M198 214 C210 208 226 208 236 212 L244 262 H206 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M198 214 C210 208 226 208 236 212 L244 262 H206 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M210 220 L228 216 L232 240 L214 244 Z" fill="#FFE3E0" opacity=".45" [attr.filter]="u('pc-blur')"/>
          <path d="M236 213 L243 260" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M198 214 C210 208 226 208 236 212 L244 262 H206 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M202 236 C214 232 228 232 240 236" fill="none" stroke="#3A0004" stroke-width="1.3" opacity=".8"/><path d="M202 237.2 C214 233.2 228 233.2 240 237.2" fill="none" stroke="#FF8A7A" stroke-width=".7" opacity=".5"/>

          <!-- costado (bajo el brazo) -->
          <path d="M148 198 L172 192 L180 234 L166 262 H146 L150 228 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M148 198 L172 192 L180 234 L166 262 H146 L150 228 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M172 193 L180 233" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M148 198 L172 192 L180 234 L166 262 H146 L150 228 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <!-- abdomen: lÃ¡minas que se afinan hacia la cintura -->
          <path d="M56 222 L120 216 L146 204 L148 222 L126 234 L60 240 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M56 222 L120 216 L146 204 L148 222 L126 234 L60 240 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M57 223 L120 217 L146 205" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M56 222 L120 216 L146 204 L148 222 L126 234 L60 240 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M62 246 L128 240 L148 228 L146 248 L130 258 L66 264 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M62 246 L128 240 L148 228 L146 248 L130 258 L66 264 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M63 247 L128 241 L148 229" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M62 246 L128 240 L148 228 L146 248 L130 258 L66 264 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <!-- pectoral esculpido -->
          <path d="M92 160 C72 166 56 182 52 206 L56 216 L118 210 L148 196 L152 166 C132 158 110 156 92 160 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M92 160 C72 166 56 182 52 206 L56 216 L118 210 L148 196 L152 166 C132 158 110 156 92 160 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M66 196 C72 180 88 170 108 166 L122 166 C102 174 86 184 76 200 Z" fill="#FFE3E0" opacity=".45" [attr.filter]="u('pc-blur')"/>
          <path d="M54 204 C58 184 72 168 92 161 C110 157 132 158 151 166" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M92 160 C72 166 56 182 52 206 L56 216 L118 210 L148 196 L152 166 C132 158 110 156 92 160 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M58 206 C74 192 104 184 148 180" fill="none" stroke="#3A0004" stroke-width="1.4" opacity=".75"/>
          <path d="M58 204.6 C74 190.6 104 182.6 148 178.6" fill="none" stroke="#FF9A8A" stroke-width=".8" opacity=".55"/>
          <circle cx="64" cy="210" r="1.6" fill="#2A0003"/><circle cx="63.5" cy="209.5" r=".7" fill="#FF9A8A" opacity=".7"/>
          <circle cx="140" cy="198" r="1.6" fill="#2A0003"/><circle cx="139.5" cy="197.5" r=".7" fill="#FF9A8A" opacity=".7"/>

          <!-- "Patagonia Chain" tatuado en el pectoral -->
          <g class="rb-tatuaje" [attr.filter]="u('pc-tinta')">
            <text class="tat-texto" transform="translate(68 196) rotate(-13) skewY(-2)">PATAGONIA CHAIN</text>
            <text class="tat-sub" transform="translate(71 202.5) rotate(-13) skewY(-2)">PC-01 Â· ROSARIO</text>
          </g>

          <!-- cuello mecÃ¡nico -->
          <path d="M118 100 L138 98 L144 152 L120 154 Z" fill="#07080A"/>
          <g class="rb-cables">
            <path d="M112 108 C108 124 110 138 106 152" fill="none" stroke="#0B0D11" stroke-width="5" stroke-linecap="round"/>
            <path d="M112 108 C108 124 110 138 106 152" fill="none" [attr.stroke]="u('pc-cable')" stroke-width="3.5" stroke-linecap="round"/>
            <path d="M112 108 C108 124 110 138 106 152" fill="none" stroke="#000" stroke-width="3.5" stroke-dasharray="1 2.6" opacity=".55"/>
            <path d="M112 108 C108 124 110 138 106 152" fill="none" stroke="#9AA4B3" stroke-width="0.7" stroke-linecap="round" opacity=".5" transform="translate(-0.9 0)"/>
            <path d="M142 102 C148 118 146 134 150 150" fill="none" stroke="#0B0D11" stroke-width="5" stroke-linecap="round"/>
            <path d="M142 102 C148 118 146 134 150 150" fill="none" [attr.stroke]="u('pc-cable')" stroke-width="3.5" stroke-linecap="round"/>
            <path d="M142 102 C148 118 146 134 150 150" fill="none" stroke="#000" stroke-width="3.5" stroke-dasharray="1 2.6" opacity=".55"/>
            <path d="M142 102 C148 118 146 134 150 150" fill="none" stroke="#9AA4B3" stroke-width="0.7" stroke-linecap="round" opacity=".5" transform="translate(-0.9 0)"/>
          </g>
          <rect x="115.9" y="106.5" width="18" height="7" rx="2.2" transform="rotate(-12 124.9 110)" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#050608" stroke-width=".8"/>
          <rect x="118" y="115.5" width="18" height="7" rx="2.2" transform="rotate(-12 127 119)" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#050608" stroke-width=".8"/>
          <rect x="120" y="124.5" width="18" height="7" rx="2.2" transform="rotate(-12 129 128)" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#050608" stroke-width=".8"/>
          <rect x="122" y="133.5" width="18" height="7" rx="2.2" transform="rotate(-12 131 137)" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#050608" stroke-width=".8"/>
          <rect x="124.1" y="142.5" width="18" height="7" rx="2.2" transform="rotate(-12 133.1 146)" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#050608" stroke-width=".8"/>
          <path d="M104 112 L100 152" stroke="#050608" stroke-width="7" stroke-linecap="round"/>
          <path d="M102.2 130 L100 152" [attr.stroke]="u('pc-cromo')" stroke-width="5" stroke-linecap="round"/>
          <path d="M104 112 L102.2 130" stroke="#C9D1DA" stroke-width="2.2" stroke-linecap="round"/>
          <circle cx="104" cy="112" r="3.8" [attr.fill]="u('pc-metal')" stroke="#050608" stroke-width=".8"/>
          <circle cx="100" cy="152" r="3.8" [attr.fill]="u('pc-metal')" stroke="#050608" stroke-width=".8"/>
          <path d="M150 102 L158 146" stroke="#050608" stroke-width="7" stroke-linecap="round"/>
          <path d="M153.6 121.8 L158 146" [attr.stroke]="u('pc-cromo')" stroke-width="5" stroke-linecap="round"/>
          <path d="M150 102 L153.6 121.8" stroke="#C9D1DA" stroke-width="2.2" stroke-linecap="round"/>
          <circle cx="150" cy="102" r="3.8" [attr.fill]="u('pc-metal')" stroke="#050608" stroke-width=".8"/>
          <circle cx="158" cy="146" r="3.8" [attr.fill]="u('pc-metal')" stroke="#050608" stroke-width=".8"/>
          <!-- collarÃ­n -->
          <path d="M84 156 C104 144 140 138 166 146 L168 160 C144 152 108 156 88 168 Z" fill="#000" opacity=".4" [attr.filter]="u('pc-ao')"/>
          <path d="M86 150 C104 140 140 134 164 142 L168 156 C144 148 106 152 90 164 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M86 150 C104 140 140 134 164 142 L168 156 C144 148 106 152 90 164 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M88 150 C106 140 140 135 163 142" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M86 150 C104 140 140 134 164 142 L168 156 C144 148 106 152 90 164 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <circle cx="124" cy="146" r="3.4" [attr.fill]="u('pc-luz')" [attr.filter]="u('pc-brillo')" class="rb-nucleo"/>

          <!-- pistÃ³n pecho-hombro -->
          <path d="M130 176 L168 158" stroke="#050608" stroke-width="6" stroke-linecap="round"/>
          <path d="M147.1 167.9 L168 158" [attr.stroke]="u('pc-cromo')" stroke-width="4" stroke-linecap="round"/>
          <path d="M130 176 L147.1 167.9" stroke="#C9D1DA" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="130" cy="176" r="3" [attr.fill]="u('pc-metal')" stroke="#050608" stroke-width=".8"/>
          <circle cx="168" cy="158" r="3" [attr.fill]="u('pc-metal')" stroke="#050608" stroke-width=".8"/>
          <!-- rÃ³tula del hombro -->
          <circle cx="192" cy="172" r="15" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#050608" stroke-width="1"/>
          <circle cx="192" cy="172" r="6" fill="#0B0D11"/>
          <!-- hombrera: dos lÃ¡minas y cÃºpula -->
          <path d="M146 132 C170 108 214 106 240 126 L248 176 L236 214 L168 210 L150 170 Z" fill="#000" opacity=".45" [attr.filter]="u('pc-ao')"/>
          <path d="M168 196 C190 200 214 200 232 196 L228 210 C210 214 190 214 174 210 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M168 196 C190 200 214 200 232 196 L228 210 C210 214 190 214 174 210 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M169 197 C190 201 214 201 231 197" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M168 196 C190 200 214 200 232 196 L228 210 C210 214 190 214 174 210 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M160 180 C186 186 216 186 240 180 L236 196 C214 202 188 202 166 196 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M160 180 C186 186 216 186 240 180 L236 196 C214 202 188 202 166 196 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M161 181 C186 187 216 187 239 181" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M160 180 C186 186 216 186 240 180 L236 196 C214 202 188 202 166 196 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M146 146 C160 120 200 106 232 120 C248 128 252 150 246 168 C232 178 196 180 160 176 C150 168 144 156 146 146 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M146 146 C160 120 200 106 232 120 C248 128 252 150 246 168 C232 178 196 180 160 176 C150 168 144 156 146 146 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M160 140 C172 124 192 116 212 116 C196 124 180 134 168 150 Z" fill="#FFE3E0" opacity=".45" [attr.filter]="u('pc-blur')"/>
          <path d="M148 146 C162 121 200 108 231 121" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M146 146 C160 120 200 106 232 120 C248 128 252 150 246 168 C232 178 196 180 160 176 C150 168 144 156 146 146 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M152 158 C178 148 216 146 246 154" fill="none" stroke="#3A0004" stroke-width="1.3" opacity=".7"/>
          <path d="M152 156.8 C178 146.8 216 144.8 246 152.8" fill="none" stroke="#FF9A8A" stroke-width=".7" opacity=".5"/>
          <circle cx="172" cy="166" r="1.6" fill="#2A0003"/><circle cx="171.5" cy="165.5" r=".7" fill="#FF9A8A" opacity=".7"/>
          <circle cx="204" cy="164" r="1.6" fill="#2A0003"/><circle cx="203.5" cy="163.5" r=".7" fill="#FF9A8A" opacity=".7"/>
          <circle cx="234" cy="162" r="1.6" fill="#2A0003"/><circle cx="233.5" cy="161.5" r=".7" fill="#FF9A8A" opacity=".7"/>
          <!-- aleta -->
          <path d="M206 116 L220 90 L226 120 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
          <path d="M206 116 L220 90 L226 120 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
          <path d="M207 116 L220 91" fill="none" stroke="#FF9A6A" stroke-width="1.8" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
          <path d="M206 116 L220 90 L226 120 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
        </g>

        <!-- cabeza de perfil (mira a la izquierda) -->
        <g class="rb-cabeza">
          <path d="M70 108 C90 114 130 108 160 96" fill="none" stroke="#000" stroke-width="10" opacity=".35" [attr.filter]="u('pc-ao')"/>
          <path d="M64 62 C62 32 92 12 126 14 C156 16 178 38 176 66 C175 82 166 94 152 100 L118 108 L92 114 C80 116 70 108 68 96 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
            <path d="M64 62 C62 32 92 12 126 14 C156 16 178 38 176 66 C175 82 166 94 152 100 L118 108 L92 114 C80 116 70 108 68 96 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
            <path d="M78 40 C90 24 112 18 132 20 C120 30 100 36 82 52 Z" fill="#FFE3E0" opacity=".55" [attr.filter]="u('pc-blur')"/>
            <path d="M66 60 C64 34 92 14 126 15" fill="none" stroke="#FF9A6A" stroke-width="2" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
            <path d="M64 62 C62 32 92 12 126 14 C156 16 178 38 176 66 C175 82 166 94 152 100 L118 108 L92 114 C80 116 70 108 68 96 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M100 18 C120 24 140 40 150 62" fill="none" stroke="#3A0004" stroke-width="1.4" opacity=".8"/>
          <path d="M101 19 C121 25 141 41 151 63" fill="none" stroke="#FF8A7A" stroke-width=".9" opacity=".5"/>
          <path d="M148 22 L164 10 L160 28 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
            <path d="M148 22 L164 10 L160 28 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
            
            
            <path d="M148 22 L164 10 L160 28 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <!-- visor de vidrio oscuro -->
          <path d="M62 56 L108 48 L112 70 L68 86 Z" [attr.fill]="u('pc-visor')"/>
          <path d="M66 58 L104 51 L105 56 L68 63 Z" fill="white" opacity=".28" [attr.filter]="u('pc-blur-s')"/>
          <path class="rb-visor" d="M72 72 L98 66" [attr.stroke]="u('pc-luz')" stroke-width="3.2" stroke-linecap="round" [attr.filter]="u('pc-brillo')"/>
          <ellipse class="rb-reflejo" cx="86" cy="78" rx="40" ry="30" [attr.fill]="u('pc-reflejo')"/>
          <!-- mentonera -->
          <path d="M70 90 L104 96 L100 114 L84 116 C76 114 72 104 70 90 Z" [attr.fill]="u('pc-rojo')" [attr.filter]="u('pc-pintura')"/>
            <path d="M70 90 L104 96 L100 114 L84 116 C76 114 72 104 70 90 Z" [attr.fill]="u('pc-sombra')" opacity=".55"/>
            
            <path d="M71 92 L103 97" fill="none" stroke="#FF9A6A" stroke-width="2" stroke-linecap="round" opacity=".75" [attr.filter]="u('pc-blur-s')"/>
            <path d="M70 90 L104 96 L100 114 L84 116 C76 114 72 104 70 90 Z" fill="none" stroke="#4A0006" stroke-width=".8" opacity=".7"/>
          <path d="M80 100 l2 12 M88 101 l1 13 M96 102 l0 12" stroke="#2A0003" stroke-width="1.2"/>
          <!-- "oreja" mecanica de metal -->
          <circle cx="138" cy="66" r="21" fill="#000" opacity=".5" [attr.filter]="u('pc-blur')"/>
          <circle cx="138" cy="66" r="20" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')"/>
          <circle cx="138" cy="66" r="15.5" fill="none" stroke="#0B0D11" stroke-width="2.4"/>
          <circle cx="138" cy="66" r="15.5" fill="none" stroke="#7D8796" stroke-width=".8" opacity=".7"/>
          <circle cx="138" cy="66" r="10.5" [attr.fill]="u('pc-metal')" [attr.filter]="u('pc-acero')" stroke="#0B0D11" stroke-width="2"/>
          <circle cx="138" cy="66" r="5.5" fill="#0B0D11"/>
          <circle cx="136.5" cy="64.5" r="2" fill="#B9C2CF" opacity=".8"/>
          <path d="M122 58 a18 18 0 0 1 13 -11" stroke="#D5DBE3" stroke-width="1.6" fill="none" stroke-linecap="round" opacity=".7"/>
        </g>

      </svg>

      <div class="robot-scan"></div>
      <div class="hud-label hud-label-tl">PC-01 // PATAGONIA CHAIN</div>
      <div class="hud-label hud-label-br">SYS ▸ ONLINE<span class="hud-caret"></span></div>
    </div>
  </div>

  <!-- Línea que atraviesa la portada -->
  <div class="hero-traverse" aria-hidden="true">
    <svg viewBox="0 0 1440 800" preserveAspectRatio="none" class="traverse-svg">
      <path class="traverse-line" d="M -60 660 Q 620 600 1500 120" />
    </svg>
  </div>

  <!-- Signature: la cordillera -->
  <div class="cordillera" aria-hidden="true">
    <svg viewBox="0 0 1440 190" preserveAspectRatio="none">
      <path class="ridge ridge-back"
        d="M0,150 L90,96 L150,128 L235,60 L310,120 L400,80 L470,130 L560,52 L650,122 L730,92 L820,138 L900,70 L990,124 L1080,88 L1160,136 L1250,64 L1330,118 L1440,90 L1440,190 L0,190 Z"/>
      <path class="ridge ridge-front"
        d="M0,170 L110,126 L190,152 L290,100 L380,150 L480,116 L570,158 L680,104 L770,150 L880,124 L970,162 L1080,112 L1180,154 L1290,120 L1380,150 L1440,132 L1440,190 L0,190 Z"/>
    </svg>
  </div>
</section>

<!-- ===== MARQUEE ===== -->
<div class="marquee-strip" aria-hidden="true">
  <div class="marquee-inner">
    <span class="marquee-item" *ngFor="let item of marqueeItems">
    <!--  <span class="marquee-text">{{ item }}</span>
      <span class="marquee-sep">◆</span>-->
    </span>
    <!-- duplicate for seamless loop -->
    <span class="marquee-item" *ngFor="let item of marqueeItems">
    <!--  <span class="marquee-text">{{ item }}</span>
      <span class="marquee-sep">◆</span> -->
    </span>
  </div>
</div>

<!-- ===== ABOUT ===== -->
<section class="about" id="quienes">
  <canvas class="about-canvas" aria-hidden="true"></canvas>

  <div class="about-content">
    <div class="about-left">
      <div class="about-head">
        <div class="section-label">{{ t.about_label }}</div>
        <h2 class="about-title" [innerHTML]="t.about_title"></h2>
        <p class="about-text" [innerHTML]="t.about_p1"></p>
        <p class="about-text" [innerHTML]="t.about_p2"></p>
      </div>

      <div class="about-telemetry">
        <div class="about-tele-item" *ngFor="let stat of stats">
          <div class="about-tele-value">{{ stat.num }}<span>{{ stat.suffix }}</span></div>
          <div class="about-tele-label">{{ lang === 'ESP' ? stat.label_esp : stat.label_eng }}</div>
        </div>
      </div>
    </div>

    <div class="about-modules">
      <div class="about-module">
      
        <div class="about-module-value">{{ t.card1_value }}</div>
        <div class="about-module-sub">{{ t.card1_sub }}</div>
      </div>
      <div class="about-module about-module--lenga">
       
        <div class="about-module-value">{{ t.card2_value }}</div>
        <div class="about-module-sub">{{ t.card2_sub }}</div>
      </div>
    </div>
  </div>
</section>

<!-- ===== SERVICES ===== -->
<section class="services" id="servicios">
  <div class="section-inner">
    <div class="section-header">
      <div>
        <div class="section-label">{{ t.services_label }}</div>
        <h2 class="section-title">{{ t.services_title }}</h2>
      </div>
      <p class="section-desc">{{ t.services_desc }}</p>
    </div>
    <div class="services-index">
      <div class="idx-list" role="tablist" aria-label="Servicios">
        <ng-container *ngFor="let s of services; let i = index">
          <button class="idx-item"
                  [class.is-active]="activeService === i"
                  [attr.aria-selected]="activeService === i"
                  [attr.aria-expanded]="activeService === i"
                  role="tab"
                  (click)="setActiveService(i)"
                  (mouseenter)="setActiveService(i)">
            <span class="idx-num">0{{ i + 1 }}</span>
            <span class="idx-name">{{ lang === 'ESP' ? s.name_esp : s.name_eng }}</span>
            <span class="idx-arrow">→</span>
          </button>

          <!-- Acordeón: solo visible en mobile, contenido inline debajo del ítem abierto -->
          <div class="idx-mobile-panel" *ngIf="activeService === i">
            <div class="service-icon" [ngSwitch]="s.icon">
              <svg *ngSwitchCase="'robot'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="8" width="14" height="11" rx="2"/><path d="M12 4.5V8M3 12v3M21 12v3M9.5 16h5"/><circle cx="12" cy="3.6" r="1"/><circle cx="9.5" cy="12.5" r="1" fill="currentColor"/><circle cx="14.5" cy="12.5" r="1" fill="currentColor"/></svg>
              <svg *ngSwitchCase="'cart'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/><path d="M3 4h2l2.4 11h10.2l2.1-8H6.2"/></svg>
              <svg *ngSwitchCase="'code'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="4" width="19" height="14" rx="2"/><path d="M8.5 9.5 6 12l2.5 2.5M15.5 9.5 18 12l-2.5 2.5M13 8.5l-2 7"/></svg>
              <svg *ngSwitchCase="'gears'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1"/></svg>
              <svg *ngSwitchCase="'brain'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 3.5A2.8 2.8 0 0 0 6.7 6.3 3.2 3.2 0 0 0 4 9.5c0 .9.4 1.8 1 2.4A3.3 3.3 0 0 0 4.5 14a3.1 3.1 0 0 0 3.1 3.1c.2 1.9 1.4 3.4 3.4 3.4 1 0 1.5-.4 1.5-.4V4.6s-1-1.1-3-1.1Z"/><path d="M14.5 3.5a2.8 2.8 0 0 1 2.8 2.8A3.2 3.2 0 0 1 20 9.5c0 .9-.4 1.8-1 2.4a3.3 3.3 0 0 1 .5 2.1 3.1 3.1 0 0 1-3.1 3.1c-.2 1.9-1.4 3.4-3.4 3.4-1 0-1.5-.4-1.5-.4V4.6s1-1.1 3-1.1Z"/></svg>
            </div>
            <p class="idx-panel-desc">{{ lang === 'ESP' ? s.desc_esp : s.desc_eng }}</p>
            <div class="service-tags">
              <span class="service-tag" *ngFor="let tag of s.tags">{{ tag }}</span>
            </div>
            <a class="service-more" (click)="ir(s.route)">
              {{ t.visit_more }}
              <span class="service-arrow">→</span>
            </a>
          </div>
        </ng-container>
      </div>

      <div class="idx-panel" (click)="ir(services[activeService].route)">
        <div class="idx-panel-inner">
          <div class="service-icon" [ngSwitch]="services[activeService].icon">
            <svg *ngSwitchCase="'robot'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="8" width="14" height="11" rx="2"/><path d="M12 4.5V8M3 12v3M21 12v3M9.5 16h5"/><circle cx="12" cy="3.6" r="1"/><circle cx="9.5" cy="12.5" r="1" fill="currentColor"/><circle cx="14.5" cy="12.5" r="1" fill="currentColor"/></svg>
            <svg *ngSwitchCase="'cart'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/><path d="M3 4h2l2.4 11h10.2l2.1-8H6.2"/></svg>
            <svg *ngSwitchCase="'code'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="4" width="19" height="14" rx="2"/><path d="M8.5 9.5 6 12l2.5 2.5M15.5 9.5 18 12l-2.5 2.5M13 8.5l-2 7"/></svg>
            <svg *ngSwitchCase="'gears'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1"/></svg>
            <svg *ngSwitchCase="'brain'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 3.5A2.8 2.8 0 0 0 6.7 6.3 3.2 3.2 0 0 0 4 9.5c0 .9.4 1.8 1 2.4A3.3 3.3 0 0 0 4.5 14a3.1 3.1 0 0 0 3.1 3.1c.2 1.9 1.4 3.4 3.4 3.4 1 0 1.5-.4 1.5-.4V4.6s-1-1.1-3-1.1Z"/><path d="M14.5 3.5a2.8 2.8 0 0 1 2.8 2.8A3.2 3.2 0 0 1 20 9.5c0 .9-.4 1.8-1 2.4a3.3 3.3 0 0 1 .5 2.1 3.1 3.1 0 0 1-3.1 3.1c-.2 1.9-1.4 3.4-3.4 3.4-1 0-1.5-.4-1.5-.4V4.6s1-1.1 3-1.1Z"/></svg>
          </div>
          <div class="idx-panel-title">{{ lang === 'ESP' ? services[activeService].name_esp : services[activeService].name_eng }}</div>
          <p class="idx-panel-desc">{{ lang === 'ESP' ? services[activeService].desc_esp : services[activeService].desc_eng }}</p>
          <div class="service-tags">
            <span class="service-tag" *ngFor="let tag of services[activeService].tags">{{ tag }}</span>
          </div>
          <div class="service-more">
            {{ t.visit_more }}
            <span class="service-arrow">→</span>
          </div>
        </div>

        <div class="idx-visual" [ngSwitch]="services[activeService].icon" aria-hidden="true">
          <!-- Robotización: brazo robótico industrial en ciclo de trabajo -->
          <svg *ngSwitchCase="'robot'" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M26 92h48"/>
            <path d="M36 92v-6h28v6"/>
            <g class="arm-lower">
              <circle cx="50" cy="80" r="5"/>
              <path d="M50 75V47"/>
              <g class="arm-upper">
                <circle cx="50" cy="44" r="4"/>
                <path d="M54 44h20"/>
                <g class="arm-claw">
                  <path d="M74 38v12M74 38h6M74 50h6"/>
                </g>
              </g>
            </g>
            <rect class="arm-box" x="74" y="76" width="10" height="10" rx="1.5" fill="currentColor" stroke="none"/>
          </svg>
          <!-- E-Commerce: productos cayendo al carrito -->
          <svg *ngSwitchCase="'cart'" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 18h8l9 42h40l8-30H27"/>
            <circle cx="35" cy="76" r="5"/>
            <circle cx="63" cy="76" r="5"/>
            <rect class="cart-item item-1" x="30" y="4" width="9" height="9" rx="2" fill="currentColor" stroke="none"/>
            <rect class="cart-item item-2" x="46" y="4" width="9" height="9" rx="2" fill="currentColor" stroke="none"/>
            <rect class="cart-item item-3" x="62" y="4" width="9" height="9" rx="2" fill="currentColor" stroke="none"/>
          </svg>
          <!-- Webs & Apps: líneas de código tipeándose -->
          <svg *ngSwitchCase="'code'" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="10" y="14" width="80" height="60" rx="6"/>
            <line x1="10" y1="28" x2="90" y2="28"/>
            <circle cx="19" cy="21" r="1.6" fill="currentColor" stroke="none"/>
            <circle cx="26" cy="21" r="1.6" fill="currentColor" stroke="none"/>
            <circle cx="33" cy="21" r="1.6" fill="currentColor" stroke="none"/>
            <path class="code-line line-1" d="M20 40h24"/>
            <path class="code-line line-2" d="M20 50h38"/>
            <path class="code-line line-3" d="M20 60h18"/>
            <rect class="code-cursor" x="40" y="57" width="6" height="9" stroke="none"/>
          </svg>
          <!-- Automatización: dos engranajes girando en sentido opuesto -->
          <svg *ngSwitchCase="'gears'" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <g transform="translate(38,54)">
              <g class="gear-rotate gear-cw">
                <circle r="13"/>
                <path d="M0 -21v9M0 12v9M-21 0h9M12 0h9M-14.8-14.8l6.4 6.4M8.4 8.4l6.4 6.4M14.8-14.8l-6.4 6.4M-8.4 8.4l-6.4 6.4"/>
              </g>
            </g>
            <g transform="translate(68,30)">
              <g class="gear-rotate gear-ccw">
                <circle r="8"/>
                <path d="M0-14v6M0 8v6M-14 0h6M8 0h6M-9.9-9.9l4.3 4.3M5.6 5.6l4.3 4.3M9.9-9.9l-4.3 4.3M-5.6 5.6l-4.3 4.3"/>
              </g>
            </g>
          </svg>
          <!-- Inteligencia Artificial: pulso + sinapsis -->
          <svg *ngSwitchCase="'brain'" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <g transform="translate(50,50) scale(2.6) translate(-12,-12)">
              <g class="brain-pulse">
                <path d="M9.5 3.5A2.8 2.8 0 0 0 6.7 6.3 3.2 3.2 0 0 0 4 9.5c0 .9.4 1.8 1 2.4A3.3 3.3 0 0 0 4.5 14a3.1 3.1 0 0 0 3.1 3.1c.2 1.9 1.4 3.4 3.4 3.4 1 0 1.5-.4 1.5-.4V4.6s-1-1.1-3-1.1Z"/>
                <path d="M14.5 3.5a2.8 2.8 0 0 1 2.8 2.8A3.2 3.2 0 0 1 20 9.5c0 .9-.4 1.8-1 2.4a3.3 3.3 0 0 1 .5 2.1 3.1 3.1 0 0 1-3.1 3.1c-.2 1.9-1.4 3.4-3.4 3.4-1 0-1.5-.4-1.5-.4V4.6s1-1.1 3-1.1Z"/>
              </g>
            </g>
            <circle class="synapse s1" cx="26" cy="24" r="2.4" fill="currentColor" stroke="none"/>
            <circle class="synapse s2" cx="76" cy="30" r="2" fill="currentColor" stroke="none"/>
            <circle class="synapse s3" cx="70" cy="70" r="2.2" fill="currentColor" stroke="none"/>
            <circle class="synapse s4" cx="22" cy="68" r="1.8" fill="currentColor" stroke="none"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== WORKS ===== -->
<section class="works" id="trabajos">
  <div class="section-inner">
    <div class="section-header">
      <div>
        <div class="section-label">{{ t.works_label }}</div>
        <h2 class="section-title">{{ t.works_title }}</h2>
      </div>
      <p class="section-desc">{{ t.works_desc }}</p>
    </div>
    <div class="works-list">
      <a class="work-row" *ngFor="let w of works; let i = index" (click)="yendo(w.url)">
        <span class="work-row-num">[{{ pad(i) }}]</span>
        <span class="work-row-main">
          <span class="work-row-name">{{ w.name }}</span>
          <span class="work-row-desc">{{ lang === 'ESP' ? w.desc_esp : w.desc_eng }}</span>
        </span>
        <span class="work-row-tags">
          <span class="work-row-tag" *ngFor="let tag of w.tags">{{ tag }}</span>
        </span>
        <span class="work-row-arrow" aria-hidden="true">→</span>
      </a>
    </div>
  </div>
</section>

<!-- ===== MÉTODO ===== -->
<section class="method-teaser" id="metodologia">
  <div class="section-inner">
    <div class="section-header">
      <div>
        <div class="section-label">{{ t.method_label }}</div>
        <h2 class="section-title">{{ t.method_title }}</h2>
      </div>
      <p class="section-desc">{{ t.method_desc }}</p>
    </div>
    <div class="method-steps">
      <ng-container *ngFor="let s of methodSteps; let last = last">
        <div class="method-step">
          <div class="method-step-num">{{ s.num }}</div>
          <div class="method-step-name">{{ lang === 'ESP' ? s.name_esp : s.name_eng }}</div>
        </div>
        <div class="method-step-sep" *ngIf="!last"></div>
      </ng-container>
    </div>
    <a class="btn btn-primary method-cta" (click)="goMethod()">{{ t.method_cta }} →</a>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="faq" id="faq">
  <div class="section-inner">
    <div class="section-header">
      <div>
        <div class="section-label">{{ t.faq_label }}</div>
        <h2 class="section-title">{{ t.faq_title }}</h2>
      </div>
      <p class="section-desc">{{ t.faq_desc }}</p>
    </div>
    <div class="faq-list">
      <div class="faq-item" *ngFor="let f of faqItems; let i = index" [class.open]="openFaqIndex === i">
        <button class="faq-question" (click)="toggleFaq(i)" [attr.aria-expanded]="openFaqIndex === i">
          <span>{{ lang === 'ESP' ? f.question_esp : f.question_eng }}</span>
          <span class="faq-icon" aria-hidden="true"></span>
        </button>
        <div class="faq-answer" *ngIf="openFaqIndex === i">
          <p>{{ lang === 'ESP' ? f.answer_esp : f.answer_eng }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== CTA ===== -->
<section class="cta-section" id="contacto">
  <div class="cta-inner">
    <div class="cta-text">
      <div class="cta-label">{{ t.cta_label }}</div>
      <h2 class="cta-title" [innerHTML]="t.cta_title"></h2>
    </div>
    <div class="cta-actions">
      <a href="https://wa.me/+543416902287" class="btn btn-cta">{{ t.cta_email }}</a>
      <a href="https://www.linkedin.com/company/patagonia-chain" target="_blank" class="btn btn-ghost">LinkedIn</a>
    </div>
  </div>
  <div class="cta-cordillera" aria-hidden="true">
    <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
      <path d="M0,100 L120,58 L220,86 L340,44 L460,84 L580,56 L700,96 L820,50 L940,84 L1060,60 L1180,92 L1300,52 L1440,80 L1440,120 L0,120 Z"/>
    </svg>
  </div>
</section>

<!-- ===== FOOTER ===== -->
<footer id="footer">
  <div class="footer-top">
    <div class="footer-brand">
      <div class="footer-brand-name">Patagonia Chain</div>
      <div class="footer-brand-sub">Rosario, Argentina — {{ t.footer_sub }}</div>
    </div>
    <div class="footer-links">
      <div class="footer-col">
        <div class="footer-col-title">{{ t.footer_nav }}</div>
        <ul>
          <li><a (click)="scrollTo('quienes')">{{ t.nav_quienes }}</a></li>
          <li><a (click)="scrollTo('servicios')">{{ t.nav_servicios }}</a></li>
          <li><a (click)="scrollTo('trabajos')">{{ t.nav_trabajos }}</a></li>
          <li><a (click)="goMethod()">{{ t.nav_metodologia }}</a></li>
          <li><a (click)="scrollTo('contacto')">{{ t.nav_contacto }}</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <div class="footer-col-title">{{ t.footer_services }}</div>
        <ul>
          <li><a (click)="ir('robotizacion')">{{ lang === 'ESP' ? 'Robotización' : 'Robotics' }}</a></li>
          <li><a (click)="ir('ecommerce')">E-Commerce</a></li>
          <li><a (click)="ir('desarrollo-web')">Webs & Apps</a></li>
          <li><a (click)="ir('automatizacion')">{{ lang === 'ESP' ? 'Automatización' : 'Automation' }}</a></li>
          <li><a (click)="ir('inteligencia-artificial')">{{ lang === 'ESP' ? 'Inteligencia Artificial' : 'Artificial Intelligence' }}</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="footer-copy">© 2026 Patagonia Chain. {{ t.footer_rights }}</div>
    <div class="footer-sys" aria-hidden="true"><i></i>SYS ▸ ONLINE · PC-01 · 32.95°S 60.65°O</div>
    <div class="footer-social">
      <a href="https://www.instagram.com/patagoniachain/?hl=es" target="_blank" aria-label="Instagram">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="2" y="2" width="20" height="20" rx="5"/>
          <circle cx="12" cy="12" r="5"/>
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
        </svg>
      </a>
      <a href="https://linkedin.com/company/patagonia-chain" target="_blank" aria-label="LinkedIn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="2" y="2" width="20" height="20" rx="4"/>
          <path d="M7 10v7M7 7v.01M12 17v-4a2 2 0 014 0v4M12 10v7"/>
        </svg>
      </a>
    </div>
  </div>
</footer>
